// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1FQYd","footer":"ModalInfo_footer__1AhpW"};